<button
  #button
  appReadOnly
  [attr.aria-atomic]="aria?.atomic"
  [attr.aria-controls]="aria?.controls"
  [attr.aria-describedby]="aria?.describedby"
  [attr.aria-expanded]="aria?.expanded"
  [attr.aria-label]="aria?.label"
  [attr.data-cy]="dataCy"
  [attr.data-tracking]="dataTracking"
  [attr.id]="id"
  [attr.role]="role"
  [autofocus]="autofocus"
  [class]="classes()"
  [disabled]="disabled || isLoading"
  [ignoreReadOnly]="ignoreReadOnly"
  [style.min-width]="minWidth"
  [type]="type"
  (click)="buttonClicked.emit($event)"
>
  @if (isLoading) {
    <app-spinner />
  } @else {
    @if (icon) {
      <svg-icon
        svgClass="svg-icon"
        [src]="icon"
        [svgStyle]="{
          'width.px': this.iconSize,
          'height.px': this.iconSize,
        }"
      />
    }
    <span class="button-content">
      <ng-content />
    </span>
  }
</button>
